import React, { useState } from "react";
import { FaStar } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { useSelector } from "react-redux";
import { formattedAmount } from "../utils/helpers/Functions.helper";

const FoodCard = ({ openProductDeletModal, handleProductClick, data }) => {
  const { theme } = useSelector((state) => state.theme);
  const [isHovered, setIsHovered] = useState(false);
  const {
    primary_image,
    name,
    rating,
    subCategory,
    price,
    additional_info,
    description,
  } = data;

  const ratingStars = Array.from({ length: 5 }, (_, index) => (
    <FaStar
      key={index}
      className={
        index < Math.round(rating) ? "text-YellowColor" : "text-gray-300"
      }
    />
  ));

  return (
    <div
      className="max-w-sm bg-transparent shadow-lg border border-lightGrayColor rounded-lg overflow-hidden transform transition-transform duration-300 hover:scale-105 hover:shadow-2xl"
      onClick={() => handleProductClick(data)} // Pass item as the data
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Image Section */}
      <div className="relative bg-lightGrayColor h-56 w-full">
        <img
          src={primary_image}
          alt={name}
          className="object-cover h-full w-full"
        />
        {/* Category Tag */}
        <span className="absolute top-2 left-2 bg-GreenColor text-white text-xs px-2 py-1 rounded-full">
          {subCategory?.name}
        </span>
        {/* Delete Button */}
        {isHovered && (
          <button
            onClick={(e) => {
              e.stopPropagation(); // Prevent triggering card click event
              openProductDeletModal(data); // Call delete modal function
            }}
            className="absolute top-2 right-2 p-1 bg-RedColor text-white rounded-full hover:bg-[#B91C1C]"
          >
            <MdDelete size={20} />
          </button>
        )}
      </div>

      {/* Content Section */}
      <div className="px-3 py-4">
        {/* Food Name */}
        <h3 className={`text-2xl font-semibold ${theme==="light"?"text-[#2D3748]":"text-[#d1d1d1]"}`}>{name}</h3>

        {/* Rating and Price */}
        <div className="flex justify-between items-center mt-2">
          {/* Price */}
          <div className="text-lg font-semibold text-[#4A5568]">
            {/* <span className="line-through text-RedColor mr-2">₹{}</span> */}
            <span className="text-[#e34e4e]">{formattedAmount(price?.$numberDecimal)}</span>
          </div>
          {/* Rating */}
          <div className="flex items-center">
            {ratingStars}
            <span className="text-[#6B7280] text-sm ml-1">({rating||0})</span>
          </div>
        </div>

        {/* Additional Info */}
        <div
          className="mt-4 text-[#4A5568]"
          dangerouslySetInnerHTML={{ __html: additional_info }}
        />

        {/* Description */}
        <div
          className="mt-2 text-[#6B7280] line-clamp-3"
          dangerouslySetInnerHTML={{
            __html: description.substring(0, 150) + "...",
          }}
        />

        {/* Policies Section */}
      </div>
    </div>
  );
};

export default FoodCard;
